function sortByProperty(arr, prop, direction = 'ASC') {
    // clone array so original is not mutated
    const clone = [...arr];

    // normalize direction
    const dir = direction.toUpperCase() === 'DESC' ? -1 : 1;

    clone.sort((a, b) => {
        let valA = a[prop];
        let valB = b[prop];

        // Handle null/undefined
        if (valA == null && valB != null) return -1 * dir;
        if (valA != null && valB == null) return 1 * dir;
        if (valA == null && valB == null) return 0;

        // Detect numeric vs string
        const isNumA = typeof valA === "number" || (!isNaN(valA) && valA !== "");
        const isNumB = typeof valB === "number" || (!isNaN(valB) && valB !== "");

        // Handle numeric comparison
        if (isNumA && isNumB) {
            return (parseFloat(valA) - parseFloat(valB)) * dir;
        }

        // String comparison A–Z, Z–A
        return valA.toString().localeCompare(valB.toString()) * dir;
    });

    return clone;
}

export {sortByProperty};